import 'angular';

    function SearchCommons ($translate) {

        var SEARCH_LOCATIONS = {
            "all": {
                label: $translate.instant('SEARCH.FILTER.ALL')
            },
            "mydocs": {
                label: $translate.instant('TOP_NAV.MY_DOCUMENTS')
            },
            "shared_with_me": {
                label: $translate.instant('SEARCH.FILTER.LOCATION.SHARED_WITH_ME')
            },
            "shared_by_me": {
                label: $translate.instant('SEARCH.FILTER.LOCATION.SHARED_BY_ME')
            },
            "current_folder": {
                label: $translate.instant('SEARCH.FILTER.LOCATION.CURRENT_FOLDER')
            }
        },
        SEARCH_TIMES = {
            "all": {
                label: $translate.instant('SEARCH.FILTER.TIME.ALL_TIME')
            },
            "7_days": {
                label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_7_DAYS')
            },
            "today": {
                label: $translate.instant('ANALYTICS.FILTER.TIME.TODAY')
            },
            "30_days": {
                label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_30_DAYS')
            },
            "custom": {
                label: $translate.instant('SEARCH.ADVANCED_SEARCH_MENU.DATE_RANGE')
            }
        },
        SEARCH_FILE_TYPES = {
            "all":{
                label: $translate.instant('SEARCH.FILTER.ALL')
            },
            "folders": {
                label: $translate.instant("SEARCH.FILTER.FILE_TYPE.FOLDERS")
            },
            "files": {
                label: $translate.instant("SEARCH.FILTER.FILE_TYPE.FILES")
            },
            "word": {
                label: "Word"
            },
            "powerpoint": {
                label: "PowerPoint"
            },
            "excel": {
                label: "Excel"
            },
            "pdf": {
                label: "PDF"
            }
        },
        SEARCH_SCOPES = {
            "none": {
                label: $translate.instant('SEARCH.FILTER.NONE')
            },
            "comments": {
                label: $translate.instant('SEARCH.FILTER.SCOPE.COMMENTS')
            },
            "name": {
                label: $translate.instant('SEARCH.FILTER.SCOPE.NAME')
            },
            "labels": {
                label: $translate.instant('SEARCH.FILTER.SCOPE.LABELS')
            },
            "content": {
                label: $translate.instant('SEARCH.FILTER.SCOPE.CONTENT')
            }
        },
        SEARCH_SORT_BY = {
            "relevance": {
                label: $translate.instant('LEFT_NAV.RELEVANCE')
            },
            "name": {
                label: $translate.instant('SEARCH.FILTER.SCOPE.NAME')
            },
            "modified_date": {
                label:  $translate.instant('SEARCH.SORT_BY.MODIFIED_DATE')
            },
            "size": {
                label: $translate.instant('LEFT_NAV.SIZE')
            },
            "type": {
                label: $translate.instant('LEFT_NAV.TYPE')
            }
        },
        // This values point to the keys in previous objects
        SEARCH_FIXED_OPTIONS = {
            LOCATIONS: {
                MY_DOCS: "mydocs",
                SHARED_WITH_ME: "shared_with_me",
                SHARED_BY_ME: "shared_by_me",
                CURRENT_FOLDER: "current_folder"
            },
            TIMES: {
                SEVEN_DAYS: "7_days",
                TODAY: "today",
                THIRTY_DAYS: "30_days",
                CUSTOM: "custom"
            },
            FILE_TYPES: {
                FOLDERS: "folders",
                FILES: "files",
                WORD: "word",
                POWERPOINT: "powerpoint",
                EXCEL: "excel",
                PDF: "pdf",
            },
            SCOPE: {
                NAME: "name",
                CONTENT: "content",
                COMMENTS: "comments",
                LABELS: "labels"
            },
            SORT_BY: {
                RELEVANCE: "relevance",
                NAME: "name",
                MODIFIED_DATE: "modified_date",
                SIZE: "size",
                TYPE: "type"
            }
        },
        SEARCH_MIMES_TRANSLATIONS = {
            "word":   ["application/msword", "application/vnd.ms-word", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
            "powerpoint":    ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
            "excel":  ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
            "pdf":    ["application/pdf"],

            "au":     ["audio/basic"],
            "ai":     ["application/postscript"],
            "aiff":   ["audio/x-aiff"],
            "avi":    ["video/msvideo", "video/avi", "video/x-msvideo"],
            "bmp":    ["image/bmp"],
            "bin":    ["application/octet-stream"],
            "bz":     ["application/x-bzip"],
            "bz2":    ["application/x-bzip2"],
            "class":  ["application/x-java-vm"],
            "csh":    ["application/x-csh"],
            "css":    ["text/css"],
            "csv":    ["text/csv"],
            "doc":    ["application/msword"],
            "docx":   ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
            "eps":    ["application/postscript"],
            "exe":    ["application/octet-stream"],
            "gif":    ["image/gif"],
            "gtar":   ["application/x-gtar"],
            "gz":     ["application/x-gzip"],
            "gzip":   ["application/x-gzip"],
            "htm":    ["text/html"],
            "html":   ["text/html"],
            "ico":    ["image/x-icon"],
            "jar":    ["application/java-archive"],
            "jpe":    ["image/jpeg"],
            "jpeg":   ["image/jpeg"],
            "jpg":    ["image/jpeg"],
            "js":     ["application/x-javascript", "application/javascript", "text/javascript"],
            "mid":    ["audio/x-midi", "audio/midi"],
            "midi":   ["audio/x-midi", "audio/midi"],
            "mov":    ["video/quicktime"],
            "mp4":    ["video/mp4"],
            "mp3":    ["audio/mpeg", "audio/mp3"],
            "mpe":    ["video/mpeg"],
            "mpeg":   ["video/mpeg"],
            "mpg":    ["video/mpeg"],
            "mpkg":   ["application/vnd.apple.installer+xml"],
            "msi":    ["application/x-msi"],
            "odp":    ["application/vnd.oasis.opendocument.presentation"],
            "ods":    ["application/vnd.oasis.opendocument.spreadsheet"],
            "odt":    ["application/vnd.oasis.opendocument.text"],
            "pl":     ["application/x-perl"],
            "png":    ["image/png"],
            "ppt":    ["application/vnd.ms-powerpoint"],
            "pptx":   ["application/vnd.openxmlformats-officedocument.presentationml.presentation"],
            "ps":     ["application/postscript"],
            "pub":    ["application/x-mspublisher"],
            "qt":     ["video/quicktime"],
            "rar":    ["application/x-rar-compressed"],
            "rtf":    ["application/rtf"],
            "rtx":    ["application/rtf"],
            "ser":    ["application/x-java-serialized-object"],
            "svg":    ["image/svg+xml"],
            "swf":    ["application/x-shockwave-flash"],
            "tar":    ["application/x-tar"],
            "targz":  ["application/x-tar"],
            "tgz":    ["application/x-tar"],
            "tif":    ["image/tiff"],
            "tiff":   ["image/tiff"],
            "tsv":    ["text/tab-separated-values"],
            "txt":    ["text/plain"],
            "ua":     ["audio/basic"],
            "vsd":    ["application/vnd.visio"],
            "viv":    ["video/vnd.vivo"],
            "vivo":   ["video/vnd.vivo"],
            "wav":    ["audio/wav", "audio/x-wav"],
            "xbm":    ["image/x-xbitmap"],
            "xhtml":  ["application/xhtml+xml"],
            "xls":    ["application/vnd.ms-excel"],
            "xlsx":   ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
            "xml":    ["application/xml"],
            "zip":    ["application/zip", "application/x-compressed-zip", "multipart/x-zip"],
            "3gp":    ["video/3gpp2"],
            "7z":     ["application/x-7z-compressed"]
        };

        const searchCommons = {
          SEARCH_FILE_TYPES: SEARCH_FILE_TYPES,
          SEARCH_LOCATIONS: SEARCH_LOCATIONS,
          SEARCH_TIMES: SEARCH_TIMES,
          SEARCH_SCOPES: SEARCH_SCOPES,
          SEARCH_SORT_BY: SEARCH_SORT_BY,
          SEARCH_FIXED_OPTIONS: SEARCH_FIXED_OPTIONS,
          SEARCH_MIMES_TRANSLATIONS: SEARCH_MIMES_TRANSLATIONS
        };

        return searchCommons;
    }

    angular.module('GorillaBoy.Search')
    .factory('SearchCommons', [
        '$translate',
        SearchCommons
    ]);
